import { Bell } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { useNotificationBell } from "./useNotificationBell";

/** Bell for the rp-token shells (admin mobile top bar). Links to the Alpha inbox. */
const NotificationBell: React.FC = () => {
  const bell = useNotificationBell();
  if (!bell.visible) return null;
  return (
    <Link
      to={bell.to}
      aria-label={bell.ariaLabel}
      aria-current={bell.isCurrent ? "page" : undefined}
      data-testid="notification-bell"
      className="relative rounded-lg border border-rp-separator bg-rp-surface p-2 text-rp-grey transition-colors hover:border-gray-600 hover:text-white"
    >
      <Bell className="h-5 w-5" aria-hidden="true" />
      {bell.pillText && (
        <span
          aria-hidden="true"
          className="absolute -right-1 -top-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-rp-amber px-1 text-[10px] font-semibold leading-none text-white"
        >
          {bell.pillText}
        </span>
      )}
    </Link>
  );
};

export default NotificationBell;
